<template>
	<div class="animated fadeIn">

		<b-row>
			<b-col sm="12">

				<b-card header="Portfolio" v-if="!subscribed">
					You are currently on our FREE plan which is limited to 1 active project and 1 active employee.<br><br>
					To subscribe, select 'Subscription' in the upper right dropdown.<br><br>
					To continue on our FREE plan, select 'Manage->Projects' and 'Manage->Employees' in the left navigation pane to reduce the number of active projects and employees.
				</b-card>
				<b-card header="Portfolio" v-else>

                    <b-button-toolbar>
						<b-input-group>
							<b-form-select id="periodSelection" :plain="true" :options="['Cumulative Report','Weekly Report','Monthly Report']" v-model="currentSelection.period" v-on:change="periodChanged"></b-form-select>
						</b-input-group>
						<div class="small-space">&nbsp;&nbsp;&nbsp;</div>
						<div class="small-text" v-if="currentSelection.period == 'Weekly Report'">week of:</div>
						<div class="small-text" v-if="currentSelection.period == 'Monthly Report'">month of:</div>
						<div class="small-space">&nbsp;</div>
						<b-input-group>
							<b-form-input type="date" id="weekDate" v-if="currentSelection.period != 'Cumulative Report'" v-model="currentSelection.week" v-on:change="weekChanged"></b-form-input>
						</b-input-group>
					</b-button-toolbar>

					<br>

					<!--
					<b-button-toolbar>
						<b-input-group>
							<b-form-select id="tmeSelection" :plain="true" :options="['Total','Time','Materials','Expense']" v-model="currentSelection.tme" v-on:change="tmeChanged"></b-form-select>
						</b-input-group>
					</b-button-toolbar>

					<br>
					-->

					<div v-if="loading.portfolio">Loading, please wait...</div>
					<div v-else>
						
						<b-table hover="true" striped="true" bordered="true" small="true" responsive="md" :items="items" :fields="fields" :current-page="currentSelection.currentPage" per-page="100">
							
							<template slot="project" slot-scope="data">
									{{data.item.project}}
							</template>
							<template slot="budget_allocated" slot-scope="data">
									{{currentSelection.period == 'Cumulative Report' ? Number(data.item.budget_allocated).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0}) : '--'}}
							</template>
							<template slot="budget_used" slot-scope="data">
									{{Number(data.item.budget_used).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
							</template>
							<!--
							<template slot="budget_remaining" slot-scope="data">
									{{currentSelection.period == 'Cumulative Report' ? Number(data.item.budget_remaining).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0}) : '--'}}
							</template>
							-->
							<template slot="ev" slot-scope="data">
									{{Number(data.item.ev).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
							</template>
							<template slot="cv" slot-scope="data">
									{{Number(data.item.cv).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
							</template>
							<template slot="cpi" slot-scope="data">
									{{data.item.cpi == null ? '--' : Number(data.item.cpi).toFixed(4)}}
							</template>
							<template slot="vac" slot-scope="data">
									{{((currentSelection.period == 'Weekly Report') || (currentSelection.period == 'Monthly Report') || (data.item.vac == null)) ? '--' : Number(data.item.vac).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
							</template>
							<template slot="eac" slot-scope="data">
									{{((currentSelection.period == 'Weekly Report') || (currentSelection.period == 'Monthly Report') || (data.item.eac == null)) ? '--' : Number(data.item.eac).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
							</template>
							<template slot="etc" slot-scope="data">
									{{((currentSelection.period == 'Weekly Report') || (currentSelection.period == 'Monthly Report') || (data.item.etc == null)) ? '--' : Number(data.item.etc).toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}
							</template>

							<template slot="bottom-row" slot-scope="data">
								<td><strong>Total</strong></td>
								<td><strong>{{currentSelection.period == 'Cumulative Report' ? calculateTotal('budget_allocated').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0}) : '--'}}</strong></td>
								<td><strong>{{calculateTotal('budget_used').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</strong></td>
								<!--<td><strong>{{currentSelection.period == 'Cumulative Report' ? calculateTotal('budget_remaining').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0}) : '--'}}</strong></td>-->
								<td><strong>{{calculateTotal('ev').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</strong></td>
								<td><strong>{{calculateTotal('cv').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0})}}</strong></td>
								<td></td>
								<td><strong>{{currentSelection.period == 'Cumulative Report' ? calculateTotal('vac').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0}) : '--'}}</strong></td>
								<td><strong>{{currentSelection.period == 'Cumulative Report' ? calculateTotal('eac').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0}) : '--'}}</strong></td>
								<td><strong>{{currentSelection.period == 'Cumulative Report' ? calculateTotal('etc').toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 0}) : '--'}}</strong></td>
							</template>
							
						</b-table>
						<nav v-if="(items.length > 100)" >
							<b-pagination :total-rows="items.length" per-page="100" v-model="currentSelection.currentPage"/>
						</nav>

						<div><small>
							<strong>Budgeted At Completion (BAC)</strong>: Total project budget allocated (baseline)<br>
							<strong>Actual Cost (AC)</strong>: Project budget used<br>
							<strong>Earned Value (EV)</strong>: A quantified measurement of project progress in $, can be used as revenue recognition on an accrual basis<br>
							<strong>Cost Variance (CV)</strong>: Project cost overrun/underrun in $ (less than 0 is overrun, greater than 0 is underrun)<br>
							<strong>Cost Performance Index (CPI)</strong>: Project cost overrun/underrun as a ratio (less than 1 is overrun, greater than 1 is underrun, e.g. 0.8 means 20% overrun)<br>
							<strong>Variance At Completion (VAC)</strong>: Cost Variance (CV) forecast at project completion if current trend continues<br>
							<strong>Estimate At Completion (EAC)</strong>: Total project cost forecast at project completion if current trend continues<br>
							<strong>Estimate To Completion (ETC)</strong>: Remaining project cost forecast for project completion if current trend continues
						</small></div>

					</div>

				</b-card>

			</b-col>
		</b-row>
		<!--TODO: this is only for debugging, remove when done-->
		<!--{{this.currentSelection}}-->
	</div>

</template>



<script>

import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js'
import {poolData} from '@/shared/aws-settings'
import axios from 'axios'
import uuidv4 from 'uuid/v4'

export default {
	name: 'portfolio',

	data: () => {
		return {
			currentSelection: {
				period: 'Cumulative Report',
				tme: 'Total',
				week: '',
				currentPage: 1
			},

			currentUser: {
				cognitoUser: null,
				email: '',
				role: '',
				company: '',
				token: ''
			},

			items: [
				//{project: '', budget_allocated: 0, budget_used: 0, budget_remaining: 0, ev: 0, cv: 0, cpi: 0, vac: 0, eac: 0, etc: 0}
			],

			fields: {
				project: {label: 'Project', sortable: true, thStyle: {width: '200px'}},
				budget_allocated: {label: 'BAC', sortable: true, thStyle: {width: '100px'}},
				budget_used: {label: 'AC', sortable: true, thStyle: {width: '100px'}},
				//budget_remaining: {label: 'Budget<br>Remaining', sortable: true, thStyle: {width: '100px'}},
				ev: {label: 'EV', sortable: true, thStyle: {width: '100px'}},
				cv: {label: 'CV', sortable: true, thStyle: {width: '100px'}},
				cpi: {label: 'CPI', sortable: true, thStyle: {width: '100px'}},
				vac: {label: 'VAC', sortable: true, thStyle: {width: '100px'}},
				eac: {label: 'EAC', sortable: true, thStyle: {width: '100px'}},
				etc: {label: 'ETC', sortable: true, thStyle: {width: '100px'}}
			},

			subscribed: true,

			loading: {
				portfolio: true,
			}

		}
	},

	mounted() {

		var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
		var cognitoUser = userPool.getCurrentUser();
		var vueInstance = this;
		this.currentUser.cognitoUser = cognitoUser;

		if (cognitoUser != null) {
			cognitoUser.getSession(function(err, session) {
				if (session.isValid()) {
					vueInstance.currentUser.token = session.getIdToken().getJwtToken();
					cognitoUser.getUserAttributes(function(err, result) {
						if (err) {
							//alert(err);
							return;
						}

						for (var i = 0; i < result.length; i++) {
							if (result[i].getName() == "custom:company")
								vueInstance.currentUser.company = result[i].getValue();
							else if (result[i].getName() == "custom:role")
								vueInstance.currentUser.role = result[i].getValue();
							else if (result[i].getName() == "email")
								vueInstance.currentUser.email = result[i].getValue();
						}

						vueInstance.updateItems('Cumulative Report', 'Total', '');

						/*
						axios.get('/user-admin/stripe', {params:{token:vueInstance.currentUser.token}})
							.then(function (response) {
								if (response.data.currentPlan == 'cancel') {

									axios.get('/user-admin/active-employee-list', {params:{token:vueInstance.currentUser.token}})
										.then(function (emp) {
											if (emp.data.length > 1)
												vueInstance.subscribed = false;
										})
										.catch(function (error) {
										});

									axios.get('/project/project-list', {params:{token:vueInstance.currentUser.token}})
										.then(function (proj) {

											var activeProj = 0;
											for (var i = 0; i < proj.data.length; i++) {
												if (proj.data[i].active) {
													activeProj++;
												}
											}
											
											if (activeProj > 1)
												vueInstance.subscribed = false;

										})
										.catch(function (error) {
										});

								}
							})
							.catch(function (error) {
							});
						*/

					});
				}

			});
		}

    },

	methods: {
		periodChanged: function (event) {
			document.getElementById("periodSelection").blur();

			//set week to today
			var dateObject = new Date();
			this.currentSelection.week = dateObject.getFullYear() + '-' + (dateObject.getMonth() < 9 ? '0' : '') + (dateObject.getMonth() + 1) + '-' + (dateObject.getDate() < 10 ? '0' : '') + dateObject.getDate();

			this.updateItems(event, this.currentSelection.tme, this.currentSelection.week);
		},

		weekChanged: function (event) {
			document.getElementById("weekDate").blur();
			this.updateItems(this.currentSelection.period, this.currentSelection.tme, this.currentSelection.week);	//TODO: check different browsers that this.currentSelection.week is already set to new value here
		},

		tmeChanged: function (event) {
			document.getElementById("tmeSelection").blur();
			this.updateItems(this.currentSelection.period, event, this.currentSelection.week);
		},

		updateItems(period, tme, week) {
			var vueInstance = this;
			vueInstance.loading.portfolio = true;
			axios.get('/report/portfolio', {params:{token:vueInstance.currentUser.token, period:period, tme:tme, week:week}})
				.then(function (response) {
					vueInstance.items = JSON.parse(JSON.stringify(response.data));
					vueInstance.loading.portfolio = false;
				})
				.catch(function (error) {
					vueInstance.items = [];
					vueInstance.loading.portfolio = false;
				});
		},

		calculateTotal (column) {
			var total = 0;
			if (column == 'budget_allocated') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].budget_allocated)
				}
			}
			else if (column == 'budget_used') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].budget_used)
				}
			}
			else if (column == 'budget_remaining') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].budget_remaining)
				}
			}
			else if (column == 'ev') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].ev)
				}
			}
			else if (column == 'cv') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].cv)
				}
			}
			else if (column == 'vac') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].vac)
				}
			}
			else if (column == 'eac') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].eac)
				}
			}
			else if (column == 'etc') {
				for (var i = 0; i < this.items.length; i++) {
					total += Number(this.items[i].etc)
				}
			}
			return total;
		}

	}


}
</script>



<style>

.small-space { font-size: 20px; }

.small-text { padding-top: 5px; }

input[type=date]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
}

</style>
